import { AnyAction } from 'redux';
import {
  GlobalActions,
  TARIF_CHECKED,
  VereinbarungenChanged,
  VorbelegungPayload,
  VorversicherungChanged,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import {
  App,
  determineLaufzeit,
  getVetragsOptionenFromVorvertrag,
  Vertragsoptionen,
  VwgVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import { IAppState } from '../appState';
import { VwgActions } from '../vwgActions';

export const vwgVertragsoptionReducer = function (
  sectionState: Vertragsoptionen = null,
  action: AnyAction,
  state: IAppState,
): Vertragsoptionen {
  sectionState = vertragsoptionenReducer(sectionState, action, App.VWG_V2, state);
  switch (action.type) {
    case VwgActions.SELBSTBETEILIGUNG_CHANGED: {
      return {
        ...sectionState,
        selbstbeteiligung: action.payload.selbstbeteiligung,
      };
    }
    case TARIF_CHECKED: {
      const newState: Vertragsoptionen = cloneDeep(sectionState);
      determineLaufzeit(action, newState, state.produkt, sectionState);
      return newState;
    }
    case GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED: {
      const actionPayload: VorversicherungChanged = action.payload;
      if (actionPayload.appId === App.VWG_V2 && actionPayload.angebotsId === state.angebotsId) {
        return {
          ...sectionState,
          vorversicherungVorhanden: actionPayload.vorhanden,
        };
      }
      return sectionState;
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      return addVorvertragToAngeboteReducer(sectionState, action, App.VWG_V2, state.angebotsId);
    }
    case GlobalActions.VEREINBARUNGEN_CHANGED: {
      const actionPayload: VereinbarungenChanged = action.payload;
      const kuendigungenPayload = actionPayload.kuendingungChanged.some(
        elem => elem.appId === App.VWG_V2 && elem.angebotsId === state.angebotsId,
      );
      if (kuendigungenPayload) {
        return {
          ...sectionState,
          vorvertragGekuendigt: true,
        };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VwgVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.VWG_V2 && actionPayload.angebotsId === state.angebotsId) {
        const newState: Vertragsoptionen = getVetragsOptionenFromVorvertrag(
          sectionState,
          actionPayload,
        );
        newState.vorversicherungVorhanden = actionPayload.vorversicherungVorhanden;
        return { ...newState };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FINISHED: {
      const actionPayload: VorbelegungPayload = action.payload;
      const { appId, angebotsId } = actionPayload;
      if (appId === App.VWG_V2 && angebotsId === state.angebotsId) {
        const vwgVorbelegungdaten: VwgVorbelegungdaten =
          actionPayload.vorhandeneVorbelegungdaten as VwgVorbelegungdaten;
        const nebengebaeudeQM = vwgVorbelegungdaten.merkmale?.nebengebaeudeQM;

        return {
          ...sectionState,
          urbeginn: vwgVorbelegungdaten.urbeginn,
          vorvertragInformationen: {
            isNebengebaeudeUeber200qm: nebengebaeudeQM > 200,
          },
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
